<template>
  <div>
    <div class="editable" v-if="!readonly">
      <div class="notification is-warning has-text-weight-bold" v-if="!readonly">{{ $t('printing.warning') }}</div>
      <ValidationObserver tag="form" ref="observer">
        <div slot-scope="{valid}">
          <h2 class="title">{{ $t('printing.edit-guest') }}</h2>
          <div class="columns is-multiline">
            <div class="column is-5 is-12-desktop is-5-widescreen">
              <ValidationProvider :name="$t('general.firstname')" :rules="{required: true}" v-slot="{errors}">
                <b-field :label="$t('general.firstname')" expanded label-position="inside">
                  <b-input v-model="user.firstName"></b-input>
                  <p class="help is-danger" v-for="error in errors" :key="error">
                    {{ error }}
                  </p>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column is-7 is-12-desktop is-7-widescreen">
              <ValidationProvider :name="$t('general.lastname')" :rules="{required: true}" v-slot="{errors}">
                <b-field :label="$t('general.lastname')" expanded label-position="inside">
                  <b-input v-model="user.lastName"></b-input>
                  <p class="help is-danger" v-for="error in errors" :key="error">
                    {{ error }}
                  </p>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column is-7 is-12-desktop is-7-widescreen">
              <ValidationProvider :name="$t('general.email')" :rules="{required: true, email: true}" v-slot="{errors}">
                <b-field :label="$t('general.email')" expanded label-position="inside">
                  <b-input v-model="user.email" type="email" inputmode="email"></b-input>
                  <p class="help is-danger" v-for="error in errors" :key="error">
                    {{ error }}
                  </p>
                </b-field>
              </ValidationProvider>
            </div>

            <div class="column is-5 is-12-desktop is-5-widescreen">
              <ValidationProvider :name="$t('general.phone')" :rules="{required: true}" v-slot="{errors}">
                <b-field :label="$t('general.phone')" expanded label-position="inside">
                  <b-input v-model="user.phone" type="tel" inputmode="tel"></b-input>
                  <p class="help is-danger" v-for="error in errors" :key="error">
                    {{ error }}
                  </p>
                </b-field>
              </ValidationProvider>
            </div>
          </div>

          <div class="columns is-multiline">
            <div class="column is-7 is-12-desktop is-7-widescreen">
              <ValidationProvider :name="$t('general.address')" :rules="{required: true}" v-slot="{errors}">
                <b-field :label="$t('general.address')" label-position="inside">
                  <b-input v-model="user.address"></b-input>
                  <p class="help is-danger" v-for="error in errors" :key="error">
                    {{ error }}
                  </p>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column is-5 is-12-desktop is-5-widescreen">
              <ValidationProvider :name="$t('general.country')" :rules="{required: true}" v-slot="{errors}">
                <b-field :label="$t('general.country')" label-position="inside">
                  <b-select :placeholder="$t('general.country')" v-model="user.country" icon="globe" expanded>
                    <option v-for="option in isoCountries" :value="option.iso" :key="option.iso">{{ $t(`countries.${option.iso}`) }}</option>
                  </b-select>
                  <p class="help is-danger" v-for="error in errors" :key="error">
                    {{ error }}
                  </p>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column is-4">
              <ValidationProvider :name="$t('general.zip')" :rules="{required: true}" v-slot="{errors}">
                <b-field :label="$t('general.zip')" label-position="inside">
                  <b-input v-model="user.zip"></b-input>
                  <p class="help is-danger" v-for="error in errors" :key="error">
                    {{ error }}
                  </p>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column is-8">
              <ValidationProvider :name="$t('general.city')" :rules="{required: true}" v-slot="{errors}">
                <b-field :label="$t('general.city')" label-position="inside">
                  <b-input v-model="user.city"></b-input>
                  <p class="help is-danger" v-for="error in errors" :key="error">
                    {{ error }}
                  </p>
                </b-field>
              </ValidationProvider>
            </div>
          </div>
          <div class="buttons u-is-hend">
            <b-button type="is-dark" @click="requestSave" :disabled="!valid">{{ $t('general.edit-data') }}</b-button>

            <b-button type="is-primary" @click="requestDownload">{{ $t('general.voucher') }} {{ $t('general.print') }}</b-button>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <section class="readonly" v-if="readonly">
      <div class="columns">
        <div class="column">
          <h3 class="title is-size-6 is-marginless">{{ $t('general.user-data') }}</h3>
          <p>
            {{ user.sex | gender }} {{ user.firstName }} {{ user.lastName }}
            <br />
            {{ user.email }}
            <br />
            {{ user.phone }}
          </p>
        </div>
        <div class="column">
          <h3 class="title is-size-6 is-marginless">{{ $t('general.address-data') }}</h3>
          <p>
            {{ user.address }}
            <br />
            {{ user.zip }} {{ user.city }}
            <br />
            {{ user.country | country }}
          </p>
        </div>
      </div>
      <div class="has-text-right">
        <b-button type="is-primary" @click="requestDownload" class="is-fullwidth">{{ $t('general.voucher') }} {{ $t('general.print') }}</b-button>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'VoucherModalUser',
  props: {
    user: Object,
    readonly: Boolean,
  },
  computed: {
    ...mapGetters({
      isoCountries: 'isoCountries',
    }),
  },
  methods: {
    requestSave() {
      this.$emit('request-save')
    },
    requestDownload() {
      this.$emit('request-download')
      this.$parent.close()
    },
  },
}
</script>

<style scoped lang="sass"></style>
